module.exports = __webpack_public_path__ + "static/img/videoImg.4a741b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/videoImg.jpg
// module id = xKGP
// module chunks = 11